import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidEmail = (email) => {
  if (
    isNull(email) ||
    isUndefined(email) ||
    incorrectDataType(email, 'string') ||
    hasWhitespacesOnly(email) ||
    isEmpty(email)
  ) {
    return false;
  } else {
    const email_regex = new RegExp(/^[\w\-]+(\.[\w\-]+)*@[^\W\d_]+\.[^\W\d_]{2,4}$/);
    return email.length > 0 && email !== '' && email_regex.test(email.toLowerCase());
  }
};
